import React from "react";
import { BiSearchAlt } from "react-icons/bi";

const LambdaTable = ({ searchTerm, setSearchTerm, sortedLambdas, status }) => {
  return (
    <>
      <div className="table-header">
        <div className="card-title">
          <h4>Integration Endpoint Status</h4>
        </div>

        <div className="search-wrapper">
          <span>
            <BiSearchAlt />
          </span>
          <input
            type="text"
            placeholder="Search API endpoints..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
      </div>

      <div className="table-wrapper">
        <table className="lambda-table">
          <thead>
            <tr className="table_header_row">
              <th>Integration Name</th>
              <th className="status-col">Last Failure Time</th>
              <th className="status-col">Last Failure Date</th>
              <th className="status-col">Current Status</th>
            </tr>
          </thead>

          <tbody>
            {/* No results */}
            {(!sortedLambdas || sortedLambdas.length === 0) && (
              <tr>
                <td colSpan={4} className="no-results-cell">
                  <span className="no-results">
                    <i className="ri-search-eye-line no-results-icon"></i>
                    No results found ...
                  </span>
                </td>
              </tr>
            )}

            {/* Table rows */}
            {sortedLambdas?.map((fn) => {
              const lambdaInfo = status[fn] || {};
              const isError = lambdaInfo?.status === "🔴";

              return (
                <tr key={fn}>
                  <td className="lambda-name">{fn.replace("/", "")}</td>

                  {/* TIME */}
                  <td className="lambda-status-cell">
                    {lambdaInfo.time || "--"}
                  </td>

                  {/* DATE */}
                  <td className="lambda-status-cell">
                    {lambdaInfo.date || "--"}
                  </td>

                  {/* STATUS */}
                  <td className="lambda-status-cell">
                    <span className={`status-pill ${isError ? "error" : "ok"}`}>
                      <span className="status-dot-inner" />
                      <span className="status-text">
                        {isError ? "Error" : "OK"}
                      </span>
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default LambdaTable;
